/**
 * Src Component
 * Main component export and configuration
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// CRITICAL: i18n MUST be initialized BEFORE App import
// App and its components use withTranslation/useTranslation which require i18n to be ready
import './i18n/react-i18n'
import { AuthProvider } from './contexts/AuthContext.jsx'
import PrefsBootstrap from './i18n/PrefsBootstrap.jsx'
import App from './App.jsx'
import { initWebVitals } from './utils/reportWebVitals'

/* Unregister SW and clear caches during development to avoid stale bundles */
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations?.().then((regs) => regs.forEach((r) => r.unregister()));
  if (window.caches?.keys) {
    window.caches.keys().then((keys) => keys.forEach((k) => window.caches.delete(k)));
  }
}

if (process.env.NODE_ENV === 'production') {
  initWebVitals();
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <PrefsBootstrap />
      <App />
    </AuthProvider>
  </StrictMode>,
)
